import apiClient from './client';

export interface Account {
  id: string;
  accountNumber: string;
  accountType: string;
  currency: string;
  balance: string;
  availableBalance: string;
  status: string;
  openedAt: string;
}

export interface AccountBalance {
  balance: string;
  availableBalance: string;
  currency: string;
}

export interface Transaction {
  id: string;
  accountId: string;
  type: string;
  amount: string;
  currency: string;
  status: string;
  description: string;
  referenceNumber: string;
  initiatedAt: string;
  completedAt?: string;
}

export interface TransactionFilters {
  page?: number;
  pageSize?: number;
  type?: string;
  status?: string;
  dateFrom?: string;
  dateTo?: string;
  search?: string;
}

export interface PaginatedResponse<T> {
  data: T[];
  total: number;
  page: number;
  pageSize: number;
  totalPages: number;
}

export interface TransferRequest {
  fromAccountId: string;
  toAccountId: string;
  amount: string;
  description: string;
}

export const accountsApi = {
  list: () =>
    apiClient.get<Account[]>('/accounts'),

  getBalance: (accountId: string) =>
    apiClient.get<AccountBalance>(`/accounts/${accountId}/balance`),

  getTransactions: (accountId: string, filters?: TransactionFilters) =>
    apiClient.get<PaginatedResponse<Transaction>>(`/accounts/${accountId}/transactions`, {
      params: filters,
    }),

  transfer: (data: TransferRequest) =>
    apiClient.post('/transactions/transfer', data),
};
